import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import Route from '../route';

export default function redirectToLevelSelectIfSso(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): void
{
    if (to.query['s'])
    {
        return next({ name: Route.LevelSelect.name, query: { s: to.query['s'] } });
    }

    if (to.query['t'])
    {
        return next({ name: Route.LevelSelect.name, query: { t: to.query['t'] } });
    }

    return next();
}
